import { Component, DoCheck, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.css']
})
export class BreadcrumbComponent implements OnInit, DoCheck {
  roleName: any;
  constructor(public router: Router) { }

  ngOnInit() { }

  ngDoCheck() {
    this.roleName = sessionStorage.getItem('selectedRole-usec');
  }

}
